<template>
  <div class="my-3">
    Sign up for {{ typeTextual }} analytical roundups of cyber threat
    developments. This will be sent at the end of each {{ typeSingular }}.
  </div>
</template>

<script>
import {
  NOTIFICATION_BRIEFING_TYPE_CYBER_WEEKLY,
  NOTIFICATION_BRIEFING_TYPE_CYBER_MONTHLY,
} from "@/common/constants/notifications";

export default {
  name: "NotificationsBriefingsCyber",
  props: {
    type: {
      type: String,
      validator: (value) => {
        return (
          [
            NOTIFICATION_BRIEFING_TYPE_CYBER_WEEKLY,
            NOTIFICATION_BRIEFING_TYPE_CYBER_MONTHLY,
          ].indexOf(value) !== -1
        );
      },
    },
  },
  data: () => ({}),
  computed: {
    typeTextual() {
      return this.type === NOTIFICATION_BRIEFING_TYPE_CYBER_WEEKLY
        ? "weekly"
        : "monthly";
    },
    typeSingular() {
      return this.type === NOTIFICATION_BRIEFING_TYPE_CYBER_WEEKLY
        ? "week"
        : "month";
    },
  },
};
</script>

<style scoped></style>
